<div class="container">

  <div class="col-md-2">
    <label for="tipoVehiculo" class="form-label">Tipo de vehículo</label>
    <select class="form-select" (change)="onSelectedKindVehicle(paginationRequest)" [(ngModel)]="claseVehiculoSeleccionada" aria-label="Default select example" name="tipoVehiculo" id="tipoVehiculo" required>
      <option selected disabled>Seleccionar</option>
      <option *ngFor="let claseVehiculo of $parametricList.typeKindVehicle" [value]="claseVehiculo.idParametroDetalle">
        {{claseVehiculo.vcNombre}}</option>
    </select>

    <!-- <strong class="invalid-feedback d-block"
            *ngIf="iCantidadPasajeros.invalid && (iCantidadPasajeros.dirty || iCantidadPasajeros.touched || submitted)">
            <span *ngIf="iCantidadPasajeros.errors?.['required']">
                Campo obligatorio
            </span>
        </strong> -->
  </div>

  <br>

  <div class="overflow-auto">
    <table class="table table-bordered">
      <thead>
        <tr class="text-center">
          <th scope="col">Acción</th>
          <th scope="col">Placa del vehículo</th>
          <th scope="col">Estado</th>
          <th scope="col">Conductor</th>
          <th scope="col">Tipo de vehículo</th>
          <th scope="col">Solicitud</th>
          <th scope="col">Trayecto</th>
          <th scope="col">Recorrido</th>
          <th scope="col">Horario</th>
          <th scope="col">Cambio de estado para liberar vehículo</th>
        </tr>
      </thead>
      <tbody>
        <tr class="text-center" *ngFor="let vehiculo of dataTable">
          <td>
            <div class="form-check d-flex justify-content-center">
              <input class="form-check-input"
                *ngIf="vehiculo.vcEstadoCodigo === 'TIP_ESTADO_VEHICULO_DISPONIBLE'"
                type="checkbox"
                (change)="onSelectedCheck($event)"
                [value]="vehiculo.id"
                [checked]="valueChecked == vehiculo.id ? true:false">
            </div>
          </td>
          <td>{{vehiculo.vcPlaca}}</td>
          <td>{{vehiculo.vcEstado}}</td>
          <td>
            <select class="form-select" aria-label="Default select example" name="tipoVehiculo" id="tipoVehiculo"
              (change)="onSelectedConductor($event)" [disabled]="vehiculo.vcEstadoCodigo !== 'TIP_ESTADO_VEHICULO_DISPONIBLE'" required>
              <option selected disabled>Seleccionar</option>
              <option *ngFor="let conductor of conductores" [selected]="vehiculo.conductorId"
                [value]="conductor.id">{{conductor.vcNombreCompleto}}</option>
            </select>
          </td>
          <td>{{vehiculo.vcMarcaLinea}}</td>
          <td>{{vehiculo.solicitudId}}</td>
          <td>{{vehiculo.vcTrayecto}}</td>
          <td>{{vehiculo.vcLugar}}</td>
          <td>{{vehiculo.vcHorario}}</td>
          <td>
            <button type="button" *ngIf="vehiculo.vcEstadoCodigo === 'TIP_ESTADO_VEHICULO_ENSERVICIO' || vehiculo.vcEstadoCodigo === 'TIP_ESTADO_VEHICULO_BLOQUEADO'" class="btn btn-outline-secondary btn-sm" (click)="liberarVehiculo(vehiculo.id, vehiculo.conductorId,vehiculo.solicitudId)">
              LIBERAR
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="d-flex flex-row justify-content-center">
    <app-pagination [data]="paginationResponse" (setPagination)="onSelectedKindVehicle($event)">
    </app-pagination>
  </div>
</div>